import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("landing-page-banner", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("landing-page-banner"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
        stylable: ["background-color", "background", "background-image"],
      },
    },
  });

  BlockManager.add("landing-page-banner", {
    ...config,
    label: "Top banner",
    content: template,
  });

  editor.on("rte:action:button-status", data => {
    if (["bulletedList", "numberedList"].includes(data.type)) {
      if (data.el.matches(".landing-page-banner__title *")) data.enabled = false;
      if (data.el.matches(".landing-page-banner__button")) data.enabled = false;
    }
  });
}
